import { ChangeDetectionStrategy, Component, computed, input, inject } from '@angular/core';
import { IrisDMSFileI } from '@iris/common/modules/dms/models/IrisDMSFile';
import { IrisDmsFilesSandbox } from '@iris/common/modules/dms/sandbox/dms-files.sandbox';
import { IrisDmsPermissionsSandbox } from '@iris/common/modules/dms/sandbox/dms-permissions.sandbox';
import { IrisDmsDownloadFileButtonComponent } from '../../components/file-actions/dms-download-file-button/dms-download-file-button.component';
import { IrisDmsEditOfficeFileButtonComponent } from '../../components/file-actions/dms-edit-office-file-button/dms-edit-office-file-button.component';
import { IrisDmsFilePreviewButtonComponent } from '../../components/file-actions/dms-file-preview-button/dms-file-preview-button.component';
import { StrakitClickStopPropagationDirective } from '@ngx-strakit/cdk';

@Component({
  selector: 'iris-dms-file-grid-actions',
  imports: [
    IrisDmsDownloadFileButtonComponent,
    IrisDmsEditOfficeFileButtonComponent,
    IrisDmsFilePreviewButtonComponent,
    StrakitClickStopPropagationDirective,
  ],
  templateUrl: './file-grid-actions.component.html',
  styleUrls: ['./file-grid-actions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IrisFileGridActionsComponent {
  private readonly dmsFilesSandbox = inject(IrisDmsFilesSandbox);
  private readonly dmsPermissionsSandbox = inject(IrisDmsPermissionsSandbox);

  readonly file = input<IrisDMSFileI>();
  readonly hasUpdatePermission = computed(() => {
    return this.dmsPermissionsSandbox.hasUpdatePermissionForFile(this.file())();
  });

  readonly isOfficeEditableDocument = computed(() => {
    return this.dmsFilesSandbox.isFileEditable(this.file());
  });
}
